import { queryOptions } from '@tanstack/react-query'

import { fetchMembers, fetchRoles } from '#admin/features/access/api.ts'

/**
 * Short `staleTime`s: the person watching these lists is usually the person who just changed
 * them, and a role count that lags a reassignment reads as the reassignment having failed.
 */
export const rolesQuery = () =>
  queryOptions({
    queryKey: ['access', 'roles'],
    queryFn: ({ signal }) => fetchRoles(signal),
    staleTime: 10_000,
  })

export const membersQuery = () =>
  queryOptions({
    queryKey: ['access', 'members'],
    queryFn: ({ signal }) => fetchMembers(signal),
    staleTime: 10_000,
  })
